// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.03%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero ───────────────────────────────────── */
.pr-hero {
  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 60%, #4f46e5 100%);
  min-height: 520px;
  padding: 72px 20px 64px;
  position: relative;
  overflow: hidden;
}

.pr-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.pr-hero-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.pr-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #3730a3;
  border: 1px solid #4f46e5;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.pr-hero h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 900;
  color: #fff;
  letter-spacing: -1px;
  line-height: 1.1;
  margin-bottom: 16px;
}

.pr-hero-sub {
  font-size: 1rem;
  color: rgba(255,255,255,0.75);
  line-height: 1.65;
  max-width: 480px;
}

/* Hero form card */
.pr-form-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 28px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
}

.pr-form-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 4px;
  letter-spacing: -0.3px;
}

.pr-form-sub {
  font-size: 0.83rem;
  color: var(--muted);
  margin-bottom: 22px;
}

.pr-field {
  margin-bottom: 14px;
}

.pr-field label {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 5px;
}

.pr-field input {
  width: 100%;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  padding: 11px 14px;
  font-size: 0.95rem;
  font-family: inherit;
  color: var(--text);
  background: #f9fafb;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.pr-field input:focus { border-color: var(--p1); background: #fff; }

.pr-submit {
  width: 100%;
  background: var(--grad);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  margin-top: 6px;
  transition: opacity 0.2s, transform 0.15s;
}
.pr-submit:hover { opacity: 0.92; transform: translateY(-1px); }

.pr-form-note {
  font-size: 0.74rem;
  color: var(--muted2);
  text-align: center;
  margin-top: 10px;
  line-height: 1.5;
}

/* ── Stats bar ───────────────────────────────── */
.pr-stats {
  background: #fff;
  border-bottom: 1px solid var(--border);
}

.pr-stats-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 36px 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  text-align: center;
}

.pr-stat-val {
  font-size: clamp(2.2rem, 4vw, 3.2rem);
  font-weight: 900;
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
  line-height: 1;
}

.pr-stat-label {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 4px;
  font-weight: 600;
}

/* ── Benefits ────────────────────────────────── */
.pr-benefits {
  padding: 80px 20px;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.pr-benefits-head { margin-bottom: 52px; }

.pr-benefits-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
  text-align: left;
}

.pr-benefit {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pr-benefit-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p1);
}

.pr-benefit-title { font-size: 0.95rem; font-weight: 700; color: var(--text); }
.pr-benefit-desc { font-size: 0.85rem; color: var(--muted); line-height: 1.6; }

.pr-benefits-cta {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}

/* ── Steps ───────────────────────────────────── */
.pr-steps-section {
  background: #f8f8fb;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 80px 20px;
}

.pr-steps-inner {
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.pr-steps-head { margin-bottom: 52px; }

.pr-steps-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.pr-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.pr-step-num {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--grad);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(79,70,229,0.28);
}

.pr-step-title { font-size: 1rem; font-weight: 700; color: var(--text); }
.pr-step-desc { font-size: 0.88rem; color: var(--muted); line-height: 1.6; }

/* ── FAQ ─────────────────────────────────────── */
.pr-faq {
  padding: 80px 20px;
  max-width: 740px;
  margin: 0 auto;
}

.pr-faq-title {
  font-size: 1.6rem;
  font-weight: 800;
  text-align: center;
  color: var(--text);
  margin-bottom: 36px;
  letter-spacing: -0.4px;
}

.pr-faq-item {
  border: 1px solid var(--border);
  border-radius: 12px;
  margin-bottom: 8px;
  overflow: hidden;
  background: #fff;
}

.pr-faq-q {
  width: 100%;
  background: none;
  border: none;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  gap: 12px;
  transition: background 0.15s;
}
.pr-faq-q:hover { background: #fafafa; }

.pr-faq-icon {
  flex-shrink: 0;
  color: var(--p1);
  transition: transform 0.2s;
}
.pr-faq-icon.open { transform: rotate(180deg); }

.pr-faq-a {
  padding: 0 20px 18px;
  font-size: 0.88rem;
  color: var(--muted);
  line-height: 1.65;
}

/* ── Bottom CTA ──────────────────────────────── */
.pr-bottom-cta {
  background: linear-gradient(135deg, #1e1b4b, #4f46e5);
  padding: 72px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.pr-bottom-cta::before {
  content: '';
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  top: -80px;
  right: -80px;
}

.pr-bottom-cta-inner {
  max-width: 540px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.pr-bottom-cta h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 900;
  color: #fff;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
}

.pr-bottom-cta p {
  color: rgba(255,255,255,0.75);
  margin-bottom: 28px;
  font-size: 0.95rem;
}

.pr-bottom-form {
  display: flex;
  gap: 10px;
  max-width: 420px;
  margin: 0 auto;
}

.pr-bottom-form input {
  flex: 1 1;
  border: none;
  border-radius: 12px;
  padding: 13px 16px;
  font-size: 0.92rem;
  font-family: inherit;
  outline: none;
}

.pr-bottom-form button {
  background: #fff;
  color: var(--p1);
  border: none;
  border-radius: 12px;
  padding: 13px 22px;
  font-size: 0.92rem;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: opacity 0.2s;
}
.pr-bottom-form button:hover { opacity: 0.9; }

/* ── Hero centered variant ───────────────────── */
.pr-hero-centered .pr-hero-inner,
.pr-hero-center {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.pr-hero-centered .pr-hero-sub {
  max-width: 520px;
  margin: 0 auto;
}

.pr-hero-centered .pr-hero-badge {
  margin-left: auto;
  margin-right: auto;
}

/* ── Modal ───────────────────────────────────── */
.pr-modal {
  background: #fff;
  border-radius: 20px;
  width: min(720px,calc(100% - 32px));
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(0,0,0,0.3);
  border: none;
  padding: 0;
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
}

.pr-modal::backdrop {
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(2px);
}

.pr-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 28px 16px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.pr-modal-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.3px;
}

.pr-modal-sub {
  font-size: 0.82rem;
  color: var(--muted);
  margin-top: 2px;
}

.pr-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.pr-modal-close:hover { background: #f3f4f6; color: var(--text); }

.pr-modal-body {
  overflow-y: auto;
  padding: 20px 28px 28px;
  flex: 1 1;
}

.pr-modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}

@media (max-width: 520px) {
  .pr-modal-grid { grid-template-columns: 1fr; }
  .pr-modal-head { padding: 20px 20px 14px; }
  .pr-modal-body { padding: 16px 20px 24px; }
}

@media (max-height: 760px) {
  .pr-modal { top: 64px; max-height: calc(100vh - 88px); }
}

/* ── Alert ───────────────────────────────────── */
.pr-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 0.84rem;
  line-height: 1.5;
  margin-bottom: 16px;
}
.pr-alert-ok {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}
.pr-alert-err {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* ── Password field ──────────────────────────── */
.pr-pass-wrap {
  position: relative;
}
.pr-pass-wrap input {
  width: 100%;
  padding-right: 40px;
}
.pr-pass-eye {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  display: flex;
  align-items: center;
  padding: 0;
}

/* ── Category chips ──────────────────────────── */
.pr-cat-search-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.pr-cat-search-wrap input {
  margin-bottom: 0;
}

.pr-cat-add-btn {
  align-self: flex-start;
  background: #eef2ff;
  border: 1.5px dashed var(--p1);
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--p1);
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}
.pr-cat-add-btn:hover { background: #e0e7ff; }

.pr-cats-selected {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.pr-cats-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 140px;
  overflow-y: auto;
  padding: 4px 0;
}

.pr-cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  border: 1.5px solid #e5e7eb;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.pr-cat-chip:hover {
  border-color: var(--p1);
  color: var(--p1);
}
.pr-cat-chip.selected {
  background: #eef2ff;
  border-color: var(--p1);
  color: var(--p1);
}
.pr-cat-chip button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  margin-left: 2px;
}

/* Responsive */
@media (max-width: 860px) {
  .pr-hero-inner { grid-template-columns: 1fr; }
  .pr-form-card { max-width: 420px; }
  .pr-benefits-grid { grid-template-columns: repeat(2, 1fr); }
  .pr-steps-grid { grid-template-columns: 1fr; gap: 24px; }
  .pr-stats-inner { grid-template-columns: 1fr; }
  .pr-bottom-form { flex-direction: column; }
}
@media (max-width: 500px) {
  .pr-benefits-grid { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProviderRegister.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,0EAA0E;EAC1E,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mDAA8X;AAChY;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA,wBAAwB,uBAAuB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,yCAAyC;AAC3C;AACA,mBAAmB,aAAa,EAAE,2BAA2B,EAAE;;AAE/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9E,mBAAmB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE9E;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACxE,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE3E,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;AAC9B;AACA,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,oBAAoB,yBAAyB,EAAE;;AAE/C;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,+BAA+B,YAAY,EAAE;;AAE7C,mDAAmD;AACnD;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,UAAU;EACV,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE,kBAAkB,EAAE;;AAEjE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,iBAAiB,uBAAuB,EAAE;EAC1C,iBAAiB,uBAAuB,EAAE;AAC5C;;AAEA;EACE,YAAY,SAAS,EAAE,8BAA8B,EAAE;AACzD;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6DAA6D;AAC/D;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,gBAAgB,gBAAgB,EAAE;EAClC,oBAAoB,qCAAqC,EAAE;EAC3D,iBAAiB,0BAA0B,EAAE,SAAS,EAAE;EACxD,kBAAkB,0BAA0B,EAAE;EAC9C,kBAAkB,sBAAsB,EAAE;AAC5C;AACA;EACE,oBAAoB,0BAA0B,EAAE;AAClD","sourcesContent":["/* ── Hero ───────────────────────────────────── */\n.pr-hero {\n  background: linear-gradient(135deg, #1e1b4b 0%, #312e81 60%, #4f46e5 100%);\n  min-height: 520px;\n  padding: 72px 20px 64px;\n  position: relative;\n  overflow: hidden;\n}\n\n.pr-hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.pr-hero-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 380px;\n  gap: 60px;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n\n.pr-hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #3730a3;\n  border: 1px solid #4f46e5;\n  border-radius: 20px;\n  padding: 5px 14px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.5px;\n  margin-bottom: 20px;\n}\n\n.pr-hero h1 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -1px;\n  line-height: 1.1;\n  margin-bottom: 16px;\n}\n\n.pr-hero-sub {\n  font-size: 1rem;\n  color: rgba(255,255,255,0.75);\n  line-height: 1.65;\n  max-width: 480px;\n}\n\n/* Hero form card */\n.pr-form-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px 28px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.25);\n}\n\n.pr-form-title {\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: var(--text);\n  margin-bottom: 4px;\n  letter-spacing: -0.3px;\n}\n\n.pr-form-sub {\n  font-size: 0.83rem;\n  color: var(--muted);\n  margin-bottom: 22px;\n}\n\n.pr-field {\n  margin-bottom: 14px;\n}\n\n.pr-field label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 5px;\n}\n\n.pr-field input {\n  width: 100%;\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  padding: 11px 14px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: var(--text);\n  background: #f9fafb;\n  outline: none;\n  transition: border-color 0.2s, background 0.2s;\n}\n.pr-field input:focus { border-color: var(--p1); background: #fff; }\n\n.pr-submit {\n  width: 100%;\n  background: var(--grad);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 14px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: inherit;\n  margin-top: 6px;\n  transition: opacity 0.2s, transform 0.15s;\n}\n.pr-submit:hover { opacity: 0.92; transform: translateY(-1px); }\n\n.pr-form-note {\n  font-size: 0.74rem;\n  color: var(--muted2);\n  text-align: center;\n  margin-top: 10px;\n  line-height: 1.5;\n}\n\n/* ── Stats bar ───────────────────────────────── */\n.pr-stats {\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n}\n\n.pr-stats-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 36px 20px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  text-align: center;\n}\n\n.pr-stat-val {\n  font-size: clamp(2.2rem, 4vw, 3.2rem);\n  font-weight: 900;\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n  line-height: 1;\n}\n\n.pr-stat-label {\n  font-size: 0.85rem;\n  color: var(--muted);\n  margin-top: 4px;\n  font-weight: 600;\n}\n\n/* ── Benefits ────────────────────────────────── */\n.pr-benefits {\n  padding: 80px 20px;\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.pr-benefits-head { margin-bottom: 52px; }\n\n.pr-benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 28px;\n  text-align: left;\n}\n\n.pr-benefit {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pr-benefit-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: #eef2ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--p1);\n}\n\n.pr-benefit-title { font-size: 0.95rem; font-weight: 700; color: var(--text); }\n.pr-benefit-desc { font-size: 0.85rem; color: var(--muted); line-height: 1.6; }\n\n.pr-benefits-cta {\n  margin-top: 44px;\n  display: flex;\n  justify-content: center;\n}\n\n/* ── Steps ───────────────────────────────────── */\n.pr-steps-section {\n  background: #f8f8fb;\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  padding: 80px 20px;\n}\n\n.pr-steps-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.pr-steps-head { margin-bottom: 52px; }\n\n.pr-steps-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.pr-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n}\n\n.pr-step-num {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--grad);\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(79,70,229,0.28);\n}\n\n.pr-step-title { font-size: 1rem; font-weight: 700; color: var(--text); }\n.pr-step-desc { font-size: 0.88rem; color: var(--muted); line-height: 1.6; }\n\n/* ── FAQ ─────────────────────────────────────── */\n.pr-faq {\n  padding: 80px 20px;\n  max-width: 740px;\n  margin: 0 auto;\n}\n\n.pr-faq-title {\n  font-size: 1.6rem;\n  font-weight: 800;\n  text-align: center;\n  color: var(--text);\n  margin-bottom: 36px;\n  letter-spacing: -0.4px;\n}\n\n.pr-faq-item {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  margin-bottom: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.pr-faq-q {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 18px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text);\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  gap: 12px;\n  transition: background 0.15s;\n}\n.pr-faq-q:hover { background: #fafafa; }\n\n.pr-faq-icon {\n  flex-shrink: 0;\n  color: var(--p1);\n  transition: transform 0.2s;\n}\n.pr-faq-icon.open { transform: rotate(180deg); }\n\n.pr-faq-a {\n  padding: 0 20px 18px;\n  font-size: 0.88rem;\n  color: var(--muted);\n  line-height: 1.65;\n}\n\n/* ── Bottom CTA ──────────────────────────────── */\n.pr-bottom-cta {\n  background: linear-gradient(135deg, #1e1b4b, #4f46e5);\n  padding: 72px 20px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.pr-bottom-cta::before {\n  content: '';\n  position: absolute;\n  width: 320px;\n  height: 320px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.05);\n  top: -80px;\n  right: -80px;\n}\n\n.pr-bottom-cta-inner {\n  max-width: 540px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.pr-bottom-cta h2 {\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -0.5px;\n  margin-bottom: 8px;\n}\n\n.pr-bottom-cta p {\n  color: rgba(255,255,255,0.75);\n  margin-bottom: 28px;\n  font-size: 0.95rem;\n}\n\n.pr-bottom-form {\n  display: flex;\n  gap: 10px;\n  max-width: 420px;\n  margin: 0 auto;\n}\n\n.pr-bottom-form input {\n  flex: 1;\n  border: none;\n  border-radius: 12px;\n  padding: 13px 16px;\n  font-size: 0.92rem;\n  font-family: inherit;\n  outline: none;\n}\n\n.pr-bottom-form button {\n  background: #fff;\n  color: var(--p1);\n  border: none;\n  border-radius: 12px;\n  padding: 13px 22px;\n  font-size: 0.92rem;\n  font-weight: 800;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n.pr-bottom-form button:hover { opacity: 0.9; }\n\n/* ── Hero centered variant ───────────────────── */\n.pr-hero-centered .pr-hero-inner,\n.pr-hero-center {\n  max-width: 640px;\n  margin: 0 auto;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\n\n.pr-hero-centered .pr-hero-sub {\n  max-width: 520px;\n  margin: 0 auto;\n}\n\n.pr-hero-centered .pr-hero-badge {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ── Modal ───────────────────────────────────── */\n.pr-modal {\n  background: #fff;\n  border-radius: 20px;\n  width: min(720px,calc(100% - 32px));\n  max-height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 64px rgba(0,0,0,0.3);\n  border: none;\n  padding: 0;\n  position: fixed;\n  top: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.pr-modal::backdrop {\n  background: rgba(0,0,0,0.55);\n  backdrop-filter: blur(2px);\n}\n\n.pr-modal-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 24px 28px 16px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.pr-modal-title {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.3px;\n}\n\n.pr-modal-sub {\n  font-size: 0.82rem;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.pr-modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.pr-modal-close:hover { background: #f3f4f6; color: var(--text); }\n\n.pr-modal-body {\n  overflow-y: auto;\n  padding: 20px 28px 28px;\n  flex: 1;\n}\n\n.pr-modal-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 16px;\n}\n\n@media (max-width: 520px) {\n  .pr-modal-grid { grid-template-columns: 1fr; }\n  .pr-modal-head { padding: 20px 20px 14px; }\n  .pr-modal-body { padding: 16px 20px 24px; }\n}\n\n@media (max-height: 760px) {\n  .pr-modal { top: 64px; max-height: calc(100vh - 88px); }\n}\n\n/* ── Alert ───────────────────────────────────── */\n.pr-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  margin-bottom: 16px;\n}\n.pr-alert-ok {\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n.pr-alert-err {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n/* ── Password field ──────────────────────────── */\n.pr-pass-wrap {\n  position: relative;\n}\n.pr-pass-wrap input {\n  width: 100%;\n  padding-right: 40px;\n}\n.pr-pass-eye {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n\n/* ── Category chips ──────────────────────────── */\n.pr-cat-search-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.pr-cat-search-wrap input {\n  margin-bottom: 0;\n}\n\n.pr-cat-add-btn {\n  align-self: flex-start;\n  background: #eef2ff;\n  border: 1.5px dashed var(--p1);\n  border-radius: 20px;\n  padding: 5px 14px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--p1);\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s;\n}\n.pr-cat-add-btn:hover { background: #e0e7ff; }\n\n.pr-cats-selected {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.pr-cats-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  max-height: 140px;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n.pr-cat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #f3f4f6;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text);\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n.pr-cat-chip:hover {\n  border-color: var(--p1);\n  color: var(--p1);\n}\n.pr-cat-chip.selected {\n  background: #eef2ff;\n  border-color: var(--p1);\n  color: var(--p1);\n}\n.pr-cat-chip button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  margin-left: 2px;\n}\n\n/* Responsive */\n@media (max-width: 860px) {\n  .pr-hero-inner { grid-template-columns: 1fr; }\n  .pr-form-card { max-width: 420px; }\n  .pr-benefits-grid { grid-template-columns: repeat(2, 1fr); }\n  .pr-steps-grid { grid-template-columns: 1fr; gap: 24px; }\n  .pr-stats-inner { grid-template-columns: 1fr; }\n  .pr-bottom-form { flex-direction: column; }\n}\n@media (max-width: 500px) {\n  .pr-benefits-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
